
import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Dossier } from './dossier';
import { DossierService, DossierFilter } from './dossier.service';
import { NotifierService } from '../ui/alert/notifier.service';

import { filter as lodashFilter, size } from 'lodash';

const FILTER_KEY = 'dossiers.dialog-search-filter';

/**
 * Dossier filter dialog
 */
@Component({
  templateUrl: './dossier-search-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-136px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class DossierSearchDialogComponent implements Dialog, OnInit {
  state = 'closed';

  search: string

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  dossiers: Dossier[]
  selectedItem: Dossier
  
  onClose: () => void
  onSelect: (dossier: Dossier) => void

  constructor(
    private dossierService: DossierService,
    private notifier: NotifierService,
  ) {

  }

  ngOnInit() {
    if(!this.search) {

      // Load filter from localStorage
      if(window.localStorage) {
        try {
          this.search = window.localStorage.getItem(FILTER_KEY);
        }
        catch(err) {}
      }
      
      if(!this.search) {
        this.search = '';
      }
    }

    this.lastSearch = this.search;

    this.apply();

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  select(dossier: Dossier) {
    this.onSelect(dossier);
  }

  apply() {
    let filter = new DossierFilter();
    filter.search = this.search;
    filter.offset = 0;
    filter.limit = 10;
    filter.order_by = 'NAME';
    filter.order_direction = 'ASC';

    this.notifier.startProgress();

    this.dossierService
      .dossiers(filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        this.dossiers = result.dossiers;
        
        if(size(this.dossiers) > 0) {
          this.selectedItem = this.dossiers[0];
        }
      });

    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, this.search);
    }
  }

  hotkeys(event: KeyboardEvent){
    
    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        if(size(this.dossiers) && this.selectedItem) {
          this.select(this.selectedItem);
        }
        event.preventDefault();
        return false;
      // Up Arrow key
      case 38:
        if(size(this.dossiers) > 0) {
          let selectedIndex = this.dossiers.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex -= 1;

            if(selectedIndex >= 0) {
              this.selectedItem = this.dossiers[selectedIndex];
            }
          }
        }
        break;
      // Down Arrow key
      case 40:
        if(size(this.dossiers) > 0) {
          let selectedIndex = this.dossiers.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex += 1;

            if(selectedIndex < this.dossiers.length) {
              this.selectedItem = this.dossiers[selectedIndex];
            }
          }
        }
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.search) {
      this.lastSearch = this.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

